<kiwi-decision-content (saved)="save()">
    <div class="cell auto grid-y cell-block-y" *ngIf="decision">
        <div class="cell auto">
            <kiwi-animator-mark-explanation></kiwi-animator-mark-explanation>
            <kiwi-spacer [size]="16"></kiwi-spacer>
            <div class="grid-x grid-margin-x">
            <fieldset class="cell auto">
                <legend [i18nKey]="'decisions.animator.cooking.mark'"></legend>
                <div class="menuSalesPrices-content">
                    <table class="cell auto _tableColor">
                        <tbody>
                        <tr class="_titlePartTable">
                            <td [i18nKey]="'decisions.animator.mark.weight'"></td>
                            <td class="_number"[i18nKey]="'decisions.animator.mark'"></td>
                        </tr>
                        <tr>
                            <td>{{parameters.cookingAssignmentWeight * 100}} %</td>
                            <td>
                                <kiwi-mark-input [(ngModel)]="decision.cookingAssignmentMark"
                                                 [disabled]="decisionsReadonly"
                                                 (change)="onValueUpdate()">
                                </kiwi-mark-input>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </fieldset>
            <fieldset class="cell auto">
                <legend [i18nKey]="'decisions.animator.customer.care.mark'"></legend>
                <div class="menuSalesPrices-content">
                    <table class="cell auto _tableColor">
                        <tbody>
                        <tr class="_titlePartTable">
                            <td [i18nKey]="'decisions.animator.mark.weight'"></td>
                            <td class="_number"[i18nKey]="'decisions.animator.mark'"></td>
                        </tr>
                        <tr>
                            <td>{{parameters.customerCareAssignmentWeight * 100}} %</td>
                            <td>
                                <kiwi-mark-input [(ngModel)]="decision.customerCareAssignmentMark"
                                                 [disabled]="decisionsReadonly"
                                                 (change)="onValueUpdate()">
                                </kiwi-mark-input>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </fieldset>
            </div>
        </div>
    </div>
</kiwi-decision-content>
